import { enumOptionsToObject } from './enum-helpers'

export const productLineOptions = ['ACE', 'ATV', 'GEN', 'IND', 'PON', 'RGR', 'RZR', 'SLG', 'SNO'] as const
export const productLines = enumOptionsToObject(productLineOptions)
export type ProductLine = (typeof productLineOptions)[number]

export const activeProductLineOptions = ['ATV', 'GEN', 'IND', 'PON', 'RGR', 'RZR', 'SLG', 'SNO'] as const
export const activeProductLines = enumOptionsToObject(activeProductLineOptions)
export type ActiveProductLine = (typeof activeProductLineOptions)[number]

export const extendedProductLineOptions = [...productLineOptions, 'OperatorCustom'] as const
export const extendedProductLines = enumOptionsToObject(extendedProductLineOptions)
export type ExtendedProductLine = (typeof extendedProductLineOptions)[number]

export const ProductLinesNames = {
  ACE: 'ACE',
  ATV: 'ATV',
  GEN: 'General',
  IND: 'Indian',
  PON: 'Boat',
  RGR: 'Ranger',
  RZR: 'RZR',
  SLG: 'Slingshot',
  SNO: 'Snowmobile'
}

export function IsProductTypeOnRoad(productLine?: ProductLine | null): boolean {
  return !!(productLine && (productLine === productLines.IND || productLine === productLines.SLG))
}
